/** Promang CRA / admin — never use these as the iframe document port. */
const HOST_APP_PORTS = new Set(["3000", "3001"]);
export const DEV_VIEWER_PORT = "5081";

/**
 * Dev-only origin for probing Vite (:5081) when there is no session yet.
 * Production has no default — empty projects must not guess localhost.
 */
export function defaultViewerProbeOrigin(
  pageHostname,
  { isProduction = process.env.NODE_ENV === "production" } = {},
) {
  if (isProduction || !pageHostname) return null;
  return `http://${pageHostname}:${DEV_VIEWER_PORT}`;
}

function isLoopbackHost(hostname) {
  const h = String(hostname || "").toLowerCase();
  return h === "localhost" || h === "127.0.0.1" || h === "[::1]" || h === "::1";
}

/**
 * Point the iframe at the viewer — never at the Promang host app.
 *
 * Dev helper: swap hostname (LAN / Tailscale / localhost) and remap Promang
 * :3000/:3001 to Vite :5081. Never copy `window.location.port`.
 *
 * Production: keep the API-built `embed_url` (`VIEWER_WEB_URL` / session).
 * Hostname rewrite is not used. Reject localhost, Promang ports, and Vite
 * :5081 so the iframe cannot land on CRA or the dev server.
 */
export function rewriteViewerEmbedUrl(
  embedUrl,
  pageHostname,
  { isProduction = process.env.NODE_ENV === "production" } = {},
) {
  if (!embedUrl) return embedUrl || null;
  try {
    const url = new URL(embedUrl);

    if (isProduction) {
      if (
        isLoopbackHost(url.hostname) ||
        HOST_APP_PORTS.has(url.port) ||
        url.port === DEV_VIEWER_PORT
      ) {
        return null;
      }
      return embedUrl;
    }

    if (pageHostname) {
      url.hostname = pageHostname;
    }
    if (HOST_APP_PORTS.has(url.port)) {
      url.port = DEV_VIEWER_PORT;
    }
    return url.toString();
  } catch (_) {
    return embedUrl;
  }
}
